module.exports = __webpack_public_path__ + "static/media/soc.667dbb5a.svg";